import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export const PRODUCT_FEEDS_DATA = 'PRODUCT_FEEDS_DATA';
export const PRODUCT_FEEDS_LOADING = 'PRODUCT_FEEDS_LOADING';
export const PRODUCT_FEEDS_TOTAL_COUNT = 'PRODUCT_FEEDS_TOTAL_COUNT';
export const PRODUCT_FEEDS_PAGE = 'PRODUCT_FEEDS_PAGE';
export const PRODUCT_FEEDS_ROWS_PER_PAGE = 'PRODUCT_FEEDS_ROWS_PER_PAGE';
export const PRODUCT_FEEDS_UPLOAD = 'PRODUCT_FEEDS_UPLOAD';
export const PRODUCT_FEEDS_SET_DIALOG = 'reports_manager_set_dialog';

const initialState = {
  data: [],
  isLoading: true,
  table: {
    page: 0,
    rowsPerPage: 20,
  },
  totalCount: 0,
  upload: {
    isSubmitting: false,
    hasSubmitted: false,
  },
  dialog: {
    gotoProductFeedsModal: false,
  },
};

const productFeeds = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_FEEDS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: [],
      };

    case PRODUCT_FEEDS_DATA:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case PRODUCT_FEEDS_TOTAL_COUNT:
      return {
        ...state,
        totalCount: action.payload,
      };

    case PRODUCT_FEEDS_PAGE:
      return {
        ...state,
        table: {
          ...state.table,
          page: action.payload,
        },
      };

    case PRODUCT_FEEDS_ROWS_PER_PAGE:
      return {
        ...state,
        table: {
          ...state.table,
          page: 0,
          rowsPerPage: action.payload,
        },
      };

    case PRODUCT_FEEDS_UPLOAD:
      return {
        ...state,
        upload: {
          ...state.upload,
          ...action.payload,
        },
      };

    case PRODUCT_FEEDS_SET_DIALOG: {
      return {
        ...state,
        dialog: {
          ...state.dialog,
          ...action.payload,
        },
      };
    }

    default:
      break;
  }

  return state;
};

const persistConfig = {
  key: 'productFeeds',
  storage,
  whitelist: ['table'],
};

export default persistReducer(persistConfig, productFeeds);
